/* Close the cart drawer when the shopper clicks the dimmed page beside it
   (Jacob, 2026-10-01: "if I click outside the mini cart on the shaded area
   ... the mini cart was minimized").

   On desktop the theme opens its drawers NON-modally (dialog.show(), see the
   stacking note in jr-tokens.css), so there is no native ::backdrop and
   theme-drawer.js's own backdrop-click handler never fires. The dim is
   .page-wrapper--drawer-open::after, a fixed overlay drawn by jr-tokens.css,
   which until now let clicks fall through to the page (pointer-events: none).
   It now catches them, and because a pseudo-element dispatches its events to
   the element that owns it, every click on the dim arrives here with the
   .page-wrapper itself as the target -- nothing inside the drawer, nothing
   on the page, can produce that target while the overlay is up.

   Closes whichever <theme-drawer> is open through its own close(), so the
   drawer's history, focus and animation handling stay the theme's. Below
   990px the drawer is modal with a real backdrop and the theme already
   closes on backdrop click; this never runs there, since the overlay only
   paints on desktop. */
(() => {
  if (window.__jrDrawerScrim) return;
  window.__jrDrawerScrim = true;

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    if (!target.classList.contains('page-wrapper--drawer-open')) return;
    const drawer = document.querySelector('theme-drawer[open]');
    if (!drawer || typeof drawer.close !== 'function') return;
    event.preventDefault();
    drawer.close();
  });
})();
